import { render } from "./WizardModal.vue?vue&type=template&id=49b6e072&scoped=true"
import script from "./WizardModal.vue?vue&type=script&lang=js"
export * from "./WizardModal.vue?vue&type=script&lang=js"

import "./WizardModal.vue?vue&type=style&index=0&id=49b6e072&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b6e072"]])

export default __exports__